import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { FormattedMessage } from 'react-intl';
// import { Tabs, Tab } from 'material-ui/Tabs';

import { MANAGER_TAB, EMPLOYEE_TAB } from 'constants/DataTypes';
// import pallet from 'constants/colors';
import AppraisalList from 'components/AppraisalList';
import Loading from 'components/Loading';
import PanelMessage from 'components/panels/PanelMessage';
import {
  // setTab,
  fetchAppraisalIfNeeded,
  fetchManagerAppraisalIfNeeded,
} from 'actions/Appraisal';

// const styles = {
//   tab: {
//     wordWrap: 'break-word',
//     whiteSpace: 'normal',
//   },
// };

class Appraisals extends React.Component {
  constructor(props) {
    super(props);
    this.handleRoute = this.handleRoute.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchAppraisalIfNeeded());
    dispatch(fetchManagerAppraisalIfNeeded());
  }

  getWidth = () => window.innerWidth;

  handleRoute(pmId) {
    this.context.router.push(`/appraisals/${pmId}`);
  }

  render() {
    const {
      appraisal,
      managerAppraisal,
      hasError,
      // dispatch,
      // tab,
    } = this.props;

    if (hasError) {
      return (
        <PanelMessage
          message={(appraisal.error && appraisal.error.Message) || (managerAppraisal.error && managerAppraisal.error.Message)}
          type="error"
          iconName="error"
        />
      );
    }

    if (managerAppraisal.loading || appraisal.loading) {
      return <Loading />;
    }

    const myAppraisals = (
      <AppraisalList
        onClick={this.handleRoute}
        isManager={false}
        {...appraisal}
      />
    );

    if (!managerAppraisal.appraisals.length) return myAppraisals;

    return (
      <div style={{ position: 'relative', zIndex: 1199, paddingBottom: 16 }}>
        {/* NOTE: The manager part has been moved to Kjarni-hub */}
        {/* <Tabs
          tabItemContainerStyle={{ backgroundColor: '#fff' }}
          inkBarStyle={{ backgroundColor: pallet.primary1Color }}
          value={tab}
          onChange={t => dispatch(setTab(t))}
        >
          <Tab
            style={{ ...styles.tab, color: `${tab === EMPLOYEE_TAB ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)'}` }}
            label={<FormattedMessage id="appraisal.title.me.tab" />}
            value={EMPLOYEE_TAB}
          >
            {myAppraisals}
          </Tab>
          <Tab
            style={{ ...styles.tab, color: `${tab === MANAGER_TAB ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)'}` }}
            label={<FormattedMessage id="appraisal.title.employee.tab" />}
            value={MANAGER_TAB}
          >
            <AppraisalList
              isManager
              onClick={this.handleRoute}
              {...managerAppraisal}
            />
          </Tab>
          {this.getWidth() > 425 && <Tab disabled value="unused" />}
          {this.getWidth() > 768 && <Tab disabled value="unused1" />}
        </Tabs> */}
        {myAppraisals}
      </div>
    );
  }
}

Appraisals.propTypes = {
  dispatch: PropTypes.func,
  appraisal: PropTypes.object,
  managerAppraisal: PropTypes.object,
  tab: PropTypes.oneOf([MANAGER_TAB, EMPLOYEE_TAB]).isRequired,
  hasError: PropTypes.object,
};

Appraisals.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  appraisal: { ...state.Appraisal },
  managerAppraisal: { ...state.ManagerAppraisal },
  hasError: state.Appraisal.error || state.Appraisal.error,
  tab: state.Appraisal.tab,
});

export default connect(mapStateToProps)(Appraisals);



// WEBPACK FOOTER //
// ./src/containers/Appraisals.js